import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';

import {
    Flex, Image, Text, Button, Link
} from 'components/ui';
import { Container } from 'components/ui';

import localeUtils from 'utils/LanguageLocale';

function ErrorPage() {
    const getText = localeUtils.getLocaleResourceFile('components/CreatorStoreFront/ErrorPage/locales', 'ErrorPage');

    return (
        <Container
            id='csf_error_page_wrapper'
            paddingTop={7}
            paddingBottom={9}
        >
            <Flex
                flexDirection='column'
                alignItems='center'
                gap={4}
            >
                <Image
                    src='/img/ufe/inactive.svg'
                    display='block'
                    size={101}
                    disableLazyLoad={true}
                />
                <Flex
                    flexDirection='column'
                    alignItems='center'
                    textAlign='center'
                    gap={2}
                >
                    <Text
                        is='h2'
                        fontWeight='bold'
                        fontSize={['base', null, 'lg']}
                        lineHeight={['18px', null, '22px']}
                        children={getText('title')}
                    />
                    <Text
                        is='p'
                        lineHeight='18px'
                        children={getText('subTitle')}
                    />
                </Flex>
                <Button
                    variant='primary'
                    href='/'
                    children={getText('ctaText')}
                />
                <Link
                    href='/beauty/international-websites'
                    color='blue'
                    children={getText('linkText')}
                />
            </Flex>
        </Container>
    );
}

export default wrapFunctionalComponent(ErrorPage, 'ErrorPage');
